<form nestableForm data-testid="xi-2-profitloss-form">

    <div [height]="15"></div>
    <div *ngIf="isShowClose" class="close-cnt cnt-row">
        <div class="filler"></div><close-btn (click)="onClose()"></close-btn><div [width]="10"></div>
    </div>
    <div class="cnt-column" style="align-items: stretch">
        <div class="h1Font text-center" i18n>{{ 'PROFIT_LOSS_ACCOUNTS_IMPORT' |  translate }}</div>
        <div [height]="30"></div>
        <div class="pane">
            <div [height]="12"></div>
            <div class="cnt-row-centered" style="justify-content: center">
                <div class="profitLoss-img">
                </div>
            </div>
            <div [height]="30"></div>
            <span class="h3Font b1Color titleTxt" i18n>
                {{ 'ACCOUNTS_SUCCESSFULLY_IMPORTED_AND' | translate}}
            </span>
            <div class="p1Font b1Color titleTxt" i18n>
                {{ 'YOUR_XERO_ACCOUNTS_ARE' | translate }}<br />
                {{ 'THESE_CAN_BE_CHANGED' | translate }}
            </div>
            <div [height]="30"></div>
        </div>
        <div style="height: 20px;"></div>

        <div *ngFor="let item of plAccountsData | keyvalue: sortNull">
            <div class="pane">
                <div class="cnt-row-centered">
                    <infoPopUp [pFieldID]="item.key"
                               [logoText]="''"
                               (infoOpened)="closeOtherInfoPanels($event)"
                               [dCreator]="getDialogCreator()">
                    </infoPopUp>
                    <div [width]="5"></div><div class="h2font accountTitle b1Color" attr.data-testid="accountTitle-{{item.key}}"> {{item.key}} </div></div>
                <div [height]="5"></div>
                <div class="line g4background"></div>

                <ng-template #noneTempl>
                    <div class="account"
                         list-drop-target
                         [getPosition]="getDropPosition.bind(this)"
                         [isDropAllowed]="isDropAllowed.bind(this)"
                         [onDragOver]="onDragOver.bind(this)"
                         [onDragEnter]="onDragEnter.bind(this)"
                         [onDragLeave]="onDragLeave.bind(this)"
                         [onItemDragOver]="onItemDragOver.bind(this)"
                         [onItemDragEnter]="onItemDragEnter.bind(this)"
                         [onItemDragLeave]="onItemDragLeave.bind(this)"
                         [onDrop]="onDrop.bind(this)"
                         (drop)="onDropping(item, dummyAccount, $event)">
                        <div class="cnt-row"
                             draggabled
                             [textFunc]="getTxt"
                             [dragData]="getDragData(dummyAccount)"
                             [draggabledObject]="{self: this, component: dummyAccount}"
                             [isDragAllowed]="isDragAllowed"
                             (drgstart)="drgstart($event)">

                            <div [height]="10"></div>
                            <div class="noneCls p1font" i18n>{{ 'NONE' | translate }}</div>
                            <div [height]="10"></div>
                        </div>
                    </div>
                </ng-template>

                <ng-container *ngIf="!isGroupNone(item.key); else noneTempl">
                    <ng-container *ngFor="let subHeading of subHeadingsMap.get(item.key); let i = index; let cnt = count">
                        <div *ngIf="subHeading" [height]="10"></div>
                        <div *ngIf="subHeading" class="cnt-row-centered">
                            <infoPopUp [pFieldID]="subHeading === 'Inventory' ? 'PLAccountsInventory' : subHeading"
                                       [logoText]="''"
                                       (infoOpened)="closeOtherInfoPanels($event)"
                                       [dCreator]="getDialogCreator()">
                            </infoPopUp>
                            <div [width]="5"></div><div class="h3font accountTitle b1color" attr.data-testid="accountTitle-{{item.key}}/{{subHeading}}"> {{subHeading}} </div></div>
                        <div [height]="10"></div>
                        <ng-container *ngIf="itemsBySubHeading(item.key, subHeading).length !== 0; else noneTempl"></ng-container>
                        <div *ngFor="let acc of itemsBySubHeading(item.key, subHeading)" style="margin-bottom: 3px">
                            <div *ngIf="!acc.IsHidden" class="account"
                                 list-drop-target
                                 [getPosition]="getDropPosition.bind(this)"
                                 [isDropAllowed]="isDropAllowed.bind(this)"
                                 [onDragOver]="onDragOver.bind(this)"
                                 [onDragEnter]="onDragEnter.bind(this)"
                                 [onDragLeave]="onDragLeave.bind(this)"
                                 [onItemDragOver]="onItemDragOver.bind(this)"
                                 [onItemDragEnter]="onItemDragEnter.bind(this)"
                                 [onItemDragLeave]="onItemDragLeave.bind(this)"
                                 [onDrop]="onDrop.bind(this)"
                                 (drop)="onDropping(item, acc, $event)">

                                <div class="cnt-row"
                                    draggabled
                                    [textFunc]="getTxt"
                                    [dragData]="getDragData(acc)"
                                    [draggabledObject]="{self: this, component: acc}"
                                    [isDragAllowed]="isDragAllowed"
                                    (drgstart)="drgstart($event)">

                                    <div [width]="23"></div>
                                    <div *ngIf="acc.DisplayCode" class="accountCode p1font">{{acc.DisplayCode}}</div>
                                    <div *ngIf="!acc.DisplayCode" class="accountCode p1font">{{acc.AccountCode}}</div>
                                    <div [width]="5"></div>
                                    <div *ngIf="acc.DisplayName" class="accountName p1font" attr.data-testid="accountName-{{item.key}}/{{subHeading}}-{{acc.AccountName}}"> {{acc.DisplayName}} </div>
                                    <div *ngIf="!acc.DisplayName" class="accountName p1font" attr.data-testid="accountName-{{item.key}}/{{subHeading}}-{{acc.AccountName}}"> {{acc.AccountName}} </div>
                                    <div class="filler"></div>

                                    <move-btn #moveBtn (click)="toggleDropdownPopup(item, acc, moveBtn)" data-testid="xeroAccountMoveBtn">

                                    </move-btn>

                                </div>
                                <div [height]="3"></div>
                            </div>
                        </div>
                    </ng-container>


                </ng-container>
            </div>
            <div style="height: 15px;"></div>
        </div>
    </div>

</form>
